import React, { useState, useMemo } from 'react';

export function Slide({slide}) {
  let image = (
    <img src={slide.image} alt={slide.name} className="img-fluid rounded" />
  )
  if (slide.link) {
    image = (
      <a href={slide.link} target="_blank">{image}</a>
    )
  }
  let description = '';
  if (slide.description) {
    description = (
      <div className="embla_description" dangerouslySetInnerHTML={{__html: slide.description}} />
    )
  }
  return image;
}

